import {memo} from 'react'
import { Trans } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import ContactForm from '../ContactForm'
import NoTranslate from '../NoTranslate'

function Footer() {
    return(
        <div>
            <ContactForm />
            <footer>
                <h2>Enlaces</h2>
                <div className="border-top">&nbsp;</div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <ul>
                        <li><NavLink to="/legal/terms-and-conditions" title="Abrir los Términos y condiciones">Términos y condiciones</NavLink></li>
                        <li><NavLink to="/legal/privacy-policy" title="Abrir las Políticas de Privacidad">Políticas de Privacidad</NavLink></li>
                    </ul>
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="container">
                        <br/>
                        <p className="text-center"><Trans i18nKey="footer.tagline" components={{ brand: <NoTranslate /> }} /></p>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default memo(Footer)